document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.logo-carousel-track');
  const wrapper = document.querySelector('.logo-carousel-wrapper');

  // Pause on hover
  wrapper.addEventListener('mouseenter', () => {
    carousel.style.animationPlayState = 'paused';
  });

  wrapper.addEventListener('mouseleave', () => {
    carousel.style.animationPlayState = 'running';
  });
});
